import { render, staticRenderFns } from "./GinView.vue?vue&type=template&id=426e5ba6&scoped=true"
import script from "./GinView.vue?vue&type=script&lang=js"
export * from "./GinView.vue?vue&type=script&lang=js"
import style0 from "./GinView.vue?vue&type=style&index=0&id=426e5ba6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426e5ba6",
  null
  
)

export default component.exports